/* eslint-disable react/no-danger */
import React, { Fragment, useEffect, useRef, useState } from 'react';
import fetch from 'isomorphic-unfetch';
import styled from 'styled-components';
import Collapsible from 'react-collapsible';
import orderBy from 'lodash/orderBy';
import sanitizeHtml from 'sanitize-html';
import { Hero } from '@/components/styles/JumbotronStyles';
import { WordPressAPI } from '../config';
import FooterComponent from '@/components/Footer/FooterComponent';
import Header from '@/components/Header/Header';
import SEOHead from '@/components/SEOHead/SEOHead';
import dynamic from 'next/dynamic';
import { FaqStyles, FaqPageStyles } from '@/components/Faq/FaqStyles';
import { useMediaQuery } from '@/helpers/hooks';

const TableOfContents = dynamic(
  import('@/components/Faq/TableOfContents')
);

const PullUpScheduler = dynamic(
  import("@components/PullUpScheduler/PullUpSchedulerV2")
);

const FooterNewsModal = dynamic(
  import('@/components/FooterNewsModal')
);

const scriptData = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What is 1-800Accountant?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "1-800Accountant is the leading virtual accounting firm for small businesses in every industry. Our services enable businesses to minimize tasks while maximizing tax savings, which lets owners focus their time and energy on growth while we handle the rest."
    }
  }, {
    "@type": "Question",
    "name": "Is 1-800Accountant legitimate?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "1-800Accountant was founded by veteran CPAs intent on bringing their experience gained at big international accounting firms like Price Waterhouse Coopers to small American businesses. Our tech allows businesses to move faster, but it’s the relationships they forge with our accountants that make the difference. We have provided financial expertise and guidance to over one hundred thousand small businesses and counting!"
    }
  }]
});

const AccountingTerms = ({ data }) => {
  const [headings, setHeadings] = useState(null);
  const [isSchedulerOpen, setIsSchedulerOpen] = useState(false);
  const [hideSchedulerHeader, setHideSchedulerHeader] = useState(false);
  const { acf, title } = data;
  const { meta_description, paid_campaign, additional_questions } = acf;
  const isMobile = useMediaQuery('(max-width: 992px)');
  const sections = acf.q_and_a_sections;

  useEffect(() => {
    // Parse post headings
    setHeadings(Array.from(document.querySelectorAll("h2")))
  }, [])

  useEffect(() => {
    // Enables position: sticky in blog posts
    document.documentElement.style.overflow = 'visible'

    return () => {
      // Reset overflowX to hidden to stop unwanted mobile horizontal scrolling
      document.documentElement.style.overflowX = 'hidden'
    }
  }, []);

  const toggleScheduler = () => {
    setIsSchedulerOpen(!isSchedulerOpen);
    setHideSchedulerHeader(!hideSchedulerHeader);
  }

  return (
    <FaqPageStyles>
      <SEOHead>
        <title>{title.rendered}</title>
        <meta name="description" content={meta_description} key="description" />
        <script
          type="text/javascript"
          src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
        />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: sanitizeHtml(scriptData) }} />
      </SEOHead>
      <Header
        AdditionalQuestions={additional_questions}
        PaidCampaign={paid_campaign}
        phone_number={acf.phone_number_setup}
        leadValues={acf.lead_values}
        hideSchedulerHeader={hideSchedulerHeader}
      />
      <FaqStyles>
        <Hero Short className="hero">
          <div className="faq-container">
            <h1 className="faq-title">{acf.hero_title}</h1>
          </div>
        </Hero>
        <div className="faq-body">
          <aside className="sidebar">
            <div className="sticky-elements-wrapper">
              <div className="sticky-elements">
                {headings && (
                  <TableOfContents headings={headings} handleClick={toggleScheduler} />)}
              </div>
            </div>
          </aside>
          <div className="faq" id="faq">
            <div className="container">
              {sections.map(qa => (
                <div key={qa.section_title}>
                  <h2>{qa.section_title}</h2>
                  {qa.q_and_a.map(elem => (
                    <Collapsible trigger={elem.question} easing="ease-in-out" key={elem.question}>
                      {/* eslint-disable-next-line react/no-danger */}
                      <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(elem.answer) }} />
                    </Collapsible>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </FaqStyles>
      {/* Email Newsletter */}
      <FooterNewsModal />
      <FooterComponent phone_number={acf.phone_number_setup} />
      {isSchedulerOpen && (
        <PullUpScheduler
          setIsSchedulerOpen={setIsSchedulerOpen}
          AdditionalQuestions={additional_questions}
          leadValues={acf.lead_values}
          PaidCampaign={paid_campaign}
        />
      )}
    </FaqPageStyles>
  );
}

export const getStaticProps = async () => {
  const res = await fetch(`${WordPressAPI.pages}/468`);
  const data = await res.json();

  return {
    props: {
      data,
    },
    // revalidate: 1,
  };
};

export default AccountingTerms;
